import { DataTypeEnum, FieldPresenterModel } from '../../models';
import { USER_ENTITY_ID } from '../entity-consts';

const entryCreator: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'creationInfo.doneBy',
  normalizedName: 'creationInfo.doneBy',
  _normalizedName: 'creationInfo.doneBy',
  name: {
    en: 'Created by',
    ar: 'الإنشاء بواسطة',
  },
  dataType: DataTypeEnum.Entity,
  renderOptions: {
    editComponent: {
      component: 'RelationComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewRelationComponent',
      options: {},
    },
  },
  source: USER_ENTITY_ID,
  sources: [
    {
      entity: USER_ENTITY_ID,
    },
  ],
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
    hidden: {
      enabled: false,
      expression: '',
    },
    queryable: true,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

const entryCreatedDate: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'creationInfo.doneAt',
  normalizedName: 'creationInfo.doneAt',
  _normalizedName: 'creationInfo.doneAt',
  name: {
    en: 'Created at',
    ar: 'تاريخ الإنشاء',
  },
  description: null,
  dataType: DataTypeEnum.Date,
  renderOptions: {
    editComponent: {
      component: 'DateTimeComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewDateTimeComponent',
      options: {},
    },
  },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
    hidden: {
      enabled: false,
      expression: '',
    },
    queryable: true,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;
const entryId: FieldPresenterModel = {
  specificationVersion: 1,
  id: '_id',
  normalizedName: '_id',
  _normalizedName: '_id',
  name: {
    en: 'Entry Id',
    ar: 'معرف المدخل',
  },
  description: null,
  dataType: DataTypeEnum.Text,
  renderOptions: {
    editComponent: {
      component: 'TextInputComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewTextComponent',
      options: {},
    },
  },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
    hidden: {
      enabled: false,
      expression: '',
    },
    queryable: true,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

const entryVersion: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'entityVersion',
  normalizedName: 'entityVersion',
  _normalizedName: 'entityVersion',
  name: {
    en: 'Entity Version',
    ar: 'إصدار الكيان',
  },
  description: null,
  dataType: DataTypeEnum.Number,
  renderOptions: {
    editComponent: {
      component: 'NumberComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewNumberComponent',
      options: {},
    },
  },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
    hidden: {
      enabled: false,
      expression: '',
    },
    queryable: true,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },
  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

const entryEditDate: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'updateInfo.doneAt',
  normalizedName: 'updateInfo.doneAt',
  _normalizedName: 'updateInfo.doneAt',
  name: {
    en: 'Updated at',
    ar: 'تاريخ التحديث',
  },
  description: null,
  dataType: DataTypeEnum.DateTime,
  renderOptions: {
    editComponent: {
      component: 'DateTimeComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewDateTimeComponent',
      options: {},
    },
  },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
    hidden: {
      enabled: false,
      expression: '',
    },
    queryable: true,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

const entryEditor: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'updateInfo.doneBy',
  normalizedName: 'updateInfo.doneBy',
  _normalizedName: 'updateInfo.doneBy',
  name: {
    en: 'Updated by',
    ar: 'التحديث بواسطة',
  },
  dataType: DataTypeEnum.Entity,
  renderOptions: {
    editComponent: {
      component: 'RelationComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewRelationComponent',
      options: {},
    },
  },
  source: USER_ENTITY_ID,
  sources: [
    {
      entity: USER_ENTITY_ID,
    },
  ],
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
    hidden: {
      enabled: false,
      expression: '',
    },
    queryable: true,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

export const entryStateField: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'invalidReason',
  normalizedName: 'invalidReason',
  _normalizedName: 'invalidReason',
  name: {
    en: 'Entry State',
    ar: 'حالة المدخل',
  },
  description: null,
  dataType: DataTypeEnum.Number,
  renderOptions: {
    editComponent: {
      component: 'NumberEnumSelectorComponent',
      options: {
        options: [
          {
            id: 0,
            label: 'label.OBSOLETE_ENTRY',
          },
          {
            id: 1,
            label: 'label.INVALID_REQUIREMENT_ENTRY',
          },
        ],
      },
    },
    viewComponent: {
      component: 'ViewNumberComponent',
      options: {},
    },
  },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
    hidden: {
      enabled: false,
      expression: '',
    },
    queryable: true,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },
  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

export const ENTRY_META_FIELDS: FieldPresenterModel[] = [
  entryCreator,
  entryCreatedDate,
  entryEditor,
  entryEditDate,
  entryId,
  entryVersion,
];
